import { useAuthSlideContextSelector } from "../AuthSlide/hook/useAuthSlideContext";
import { FlexRowAlignCenter } from "@/components/Flex";
import Image from "next/image";
import Link from "@/components/wrappers/Link";
import styles from "../auth.module.css";
import { ASSETS_URL } from "@/config/deployConstants";
import clsx from "clsx";
import br from "@/styles/breakpoints.module.css";
import TabsAlternate from "@/components/Tabs/styled/TabsAlternate";

const AuthKnowtTabHeader = ({ hideTab }: { hideTab?: boolean }) => {
    const openAuthSlide = useAuthSlideContextSelector(state => state.openAuthSlide);
    const authSlideStates = useAuthSlideContextSelector(state => state.authSlideStates);
    const closeAuthSlide = useAuthSlideContextSelector(state => state.closeAuthSlide);

    return (
        <FlexRowAlignCenter
            className={clsx(styles.tabHeaderSidePadding, br.smDownJustifyCenter)}
            style={{
                justifyContent: "space-between",
                paddingBlock: "3.5rem",
                height: "12.5rem",
                flexShrink: 0,
                flexWrap: "wrap",
                gap: "1rem",
            }}>
            <Link href={"/"} data-testid="auto-id-b0345089-b68e-49e6-9874-cef308486a9f">
                <Image
                    onClick={() => closeAuthSlide()}
                    src={`${ASSETS_URL}/images/knowt-logo.svg`}
                    alt="knowt logo"
                    width={"130"}
                    height={"42"}
                    style={{ objectFit: "contain" }}
                />
            </Link>
            {!hideTab && (
                <TabsAlternate
                    onChange={tab => {
                        tab?.action?.();
                    }}
                    selectedTab={authSlideStates.showLoginPage ? 0 : authSlideStates.showSignupPage ? 1 : 0}
                    tabSx={{ fontSize: "1.5rem" }}
                    tabsSx={{ height: "5.5rem" }}
                    tabs={[
                        {
                            label: "Log In",
                            tooltip: "Switch to login",
                            value: 0,
                            action: () => openAuthSlide({ showLoginPage: true }),
                        },
                        {
                            label: "Sign Up",
                            tooltip: "Switch to sign up",
                            value: 1,
                            action: () => openAuthSlide({ showSignupPage: true }),
                        },
                    ]}
                />
            )}
        </FlexRowAlignCenter>
    );
};

export default AuthKnowtTabHeader;
